import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Order/OrderBilling.requests'
import {
    PositionPrePopulationType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const useLoadAutoPopulatePosition = ({
    invoiceId,
    positionCode,
    enabled,
}:
    {
        invoiceId: number,
        positionCode: string,
        enabled: boolean
    }) => {
    return useRequest<PositionPrePopulationType>({
        key: RequestKeys.getAutoPopulatePosition,
        params: {
            outgoingInvoiceId: invoiceId,
            positionCode,
        },
        requestFunc: RequestFn.getEntity(requests.getPositionPrePopulation),
        enabled: Boolean(enabled && positionCode),
    })
}

export default useLoadAutoPopulatePosition
